/* eslint-disable camelcase */

import React from "react";

import { SingleCompany, CompanyPerkOrBenefit } from "interfaces/api/apiInterfaces";
import { HealthAndWellnessIcon } from "components/icons/HealthAndWellnessIcon";
import { FinanceIcon } from "components/icons/FinanceIcon";
import { OfficeLifeIcon } from "components/icons/OfficeLifeIcon";
import { ProfessionalDevelopmentIcon } from "components/icons/ProfessionalDevelopmentIcon";
import { VacationAndTimeOffIcon } from "components/icons/VacationAndTimeOffIcon";
import { DiversityAndInclusionIcon } from "components/icons/DiversityAndInclusionIcon";
import { ParentalIcon } from "components/icons/ParentalIcon";
import { FlexibleIcon } from "components/icons/FlexibleIcon";

import styles from "./JobIndividualBody.module.scss";

interface PerksAndBenefitsProps {
    company: SingleCompany;
}

const iconKeys = {
    finance: <FinanceIcon />,
    health_and_wellness: <HealthAndWellnessIcon />,
    office_life: <OfficeLifeIcon />,
    professional_development: <ProfessionalDevelopmentIcon />,
    vacation_and_timeoff: <VacationAndTimeOffIcon />,
    parental_benefits: <ParentalIcon />,
    work_flexibility: <FlexibleIcon />,
    diversity_and_inclusion: <DiversityAndInclusionIcon />
};

export const PerksAndBenefits = (props: PerksAndBenefitsProps) => {
    const { company } = props;
    const { perks_and_benefits } = company;
    const hasPerksOrBenefits = perks_and_benefits ? Object.keys(perks_and_benefits).reduce(
        (pbCount: number, pbKey): number => pbCount + perks_and_benefits[pbKey].perks.length, 0
    ) > 0 : false;

    return (
        hasPerksOrBenefits ? (
            <div className={styles.perksAndBenefits}>
                <h3>Perks and Benefits</h3>
                <ul>
                    {Object.keys(perks_and_benefits).map((perkName: string) => perks_and_benefits[perkName].perks.length ? (
                        <li key={perkName}>
                            { iconKeys[perkName] }<h4>{ perks_and_benefits[perkName].name }</h4>
                            <ul>
                                {perks_and_benefits[perkName].perks.map((perkOrBenefit: CompanyPerkOrBenefit) => (
                                    <li key={perkOrBenefit.name}>{ perkOrBenefit.name }</li>
                                ))}
                            </ul>
                        </li>
                    ) : null)}
                </ul>
            </div>
        ) : null
    );
};
